import React from "react";

const Job = () => {
  window.location.href = "/jobs/";
};

export default Job;



// WEBPACK FOOTER //
// ./component/Job/index.js